"use client";

import { SafeHydrate } from "@/SafeHydrate";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { Phone, Mail, Calendar } from "lucide-react";
export default function BookAVehicle() {
  const {
    ref: mainRef,
    isVisible: mainVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  return <section id="book-a-vehicle" className="relative min-h-[60vh] flex items-center justify-center overflow-hidden section-padding px-6 bg-dark-section">
      {}
      <div className="absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1549622/img/metallic_luxury_texture.png)] bg-cover bg-center opacity-10 pointer-events-none" />
      <div className="absolute inset-0 bg-gradient-to-b from-background-dark/80 via-background-dark/40 to-background-dark/80 pointer-events-none" />

      <div ref={mainRef} className={`relative z-10 w-full max-w-4xl transition-all duration-[var(--duration-slow)] ${mainVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
        <div className="glass-effect p-8 md:p-16 text-center border-primary/30">
          <div className="inline-flex items-center justify-center size-12 rounded-lg bg-primary/10 mb-6">
            <SafeHydrate><Calendar className="size-6 text-primary" /></SafeHydrate>
          </div>
          
          <h2 className="font-display text-3xl md:text-5xl lg:text-6xl font-bold mb-6 tracking-tight text-white">
            Experience Elite <span className="text-primary">Transportation</span>
          </h2>
          
          <p className="text-muted-foreground text-lg md:text-xl max-w-2xl mx-auto mb-10 font-sans">
            Secure your professional chauffeur for airport transfers, VIP events, or hourly bookings across Los Angeles.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-12">
            <Button asChild className="btn-primary w-full sm:w-auto min-w-[240px]">
              <Link to="tel:323-492-6292">
                <Phone className="size-5 mr-2" />
                Call 323-492-6292
              </Link>
            </Button>
            
            <Button variant="outline" asChild className="btn-secondary w-full sm:w-auto min-w-[240px] border-primary text-primary hover:bg-primary hover:text-black">
              <Link to="/ReservationsPage">
                Book Online
              </Link>
            </Button>
          </div>

          <div className="pt-8 border-t border-white/10">
            <p className="text-muted-foreground text-sm md:text-base flex flex-wrap items-center justify-center gap-x-4 gap-y-2 font-sans">
              <span className="flex items-center gap-2">
                <Mail className="size-4 text-primary" />
                Email: 
                <Link to="mailto:phoenixenterprises@gmail.com" className="text-white hover:text-primary transition-colors duration-[var(--duration-fast)] focus-ring rounded px-1">
                  phoenixenterprises@gmail.com
                </Link>
              </span>
              <span className="hidden md:inline text-white/20">|</span>
              <span className="text-white/80">Available 24/7 for Reservations</span>
            </p>
          </div>
        </div>
      </div>
    </section>;
}